export default __webpack_public_path__ + "img/cf02e18ce8074685569a0ed658217db9.png";